module.exports = __webpack_public_path__ + "static/media/explore_Zeelandia.0fd2ce3d.jpg";